module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Continue.js"));
	}, "Continue");
}